import { T } from "../themes";

export default function GenderToggle({ value, onChange }) {
  return (
    <div>
      <label style={{color:T.textSub,fontSize:10,fontFamily:T.fontSans,display:"block",marginBottom:4,fontWeight:700}}>Gender</label>
      <div style={{display:"flex",gap:7}}>
        {["M","F"].map(g=>(
          <button key={g} onClick={()=>onChange(g)} style={{
            flex:1,padding:"10px 0",background:value===g?T.accent:T.surface,
            border:"none",borderRadius:T.radiusSm||10,
            boxShadow:value===g?T.shadowSm:"none",
            color:value===g?T.ink:T.textSub,fontSize:13,fontWeight:700,fontFamily:T.fontSans,
            cursor:"pointer",transition:"all 0.15s",
          }}>{g==="M"?"♂ Male":"♀ Female"}</button>
        ))}
      </div>
    </div>
  );
}
